import { Component, effect, inject, input, signal, untracked } from '@angular/core';

import { BlastService }                from 'src/app/services/blast.service';
import { UtilisateurService }          from 'src/app/services/utilisateur.service';
import { MetabaseDashboardComponent }  from 'src/app/shared/components/metabase-dashboard/metabase-dashboard.component';

const FLEET_BLAST_FILTER_SITE_ID = 189;

/** Onglet Fleet Management System de l'ancien front (tir-detail, onglet 10). */
@Component({
  selector:   'app-legacy-blast-fleet',
  standalone: true,
  imports:    [MetabaseDashboardComponent],
  template: `
    @if (loaded()) {
      <app-metabase-dashboard componentSelector="app-tir-detail" class="w-100" [blast]="blastName()" />
    }
  `,
  styles: [':host { display: block; width: 100%; }'],
})
export class LegacyBlastFleetComponent {
  readonly blastId = input.required<number>();

  private readonly blastService = inject(BlastService);
  private readonly user         = inject(UtilisateurService);

  protected readonly blastName = signal('');
  protected readonly loaded    = signal(false);

  constructor() {
    effect(() => {
      const blastId = this.blastId();
      untracked(() => this.init(blastId));
    });
  }

  /** Comme TirDetailComponent.changerTab(10) : le nom du tir n'est transmis au dashboard que pour le site 189. */
  private init(blastId: number): void {
    this.loaded.set(false);
    this.blastName.set('');

    if (this.user.currentSite()?.siteId !== FLEET_BLAST_FILTER_SITE_ID) {
      this.loaded.set(true);
      return;
    }

    this.blastService.getBlast(blastId).subscribe(tir => {
      if (blastId !== this.blastId()) return;
      this.blastName.set(tir?.nom ?? '');
      this.loaded.set(true);
    });
  }
}
